export enum NotificationStatuses {
  DeclinedPending = 'declined_pending',
  Viewed = 'viewed',
}

export enum DistributionMethod {
  Upload = 'upload',
  Bulk = 'bulk',
  BulkMatched = 'bulk_match',
}

export enum LogTypes {
  StatusChanged = 'status_changed',
  FileUpdated = 'file_updated',
}
